import BRecipeList from "./BRecipeList";

function handleSortChange(event) {
    const radio = event.target;
    const list = radio.closest("[data-list]");
    if (!list) {
        return;
    }

    list.dataset.sort = radio.value;
    BRecipeList.reload(list);
}

export default {
    initialize() {
        document.querySelectorAll(".rcp-filter [name=\"sorting\"]").forEach(radio => {
            radio.addEventListener("change", handleSortChange);
        });
    },
};
